export interface ElementItem {
    name: string;
    title: string;
    image: string;
    active: boolean;
}

export const elements: ElementItem[] = [
  {
    name: 'red',
    title: 'Red mana',
    image: 'redElement',
    active: false,
  },
  {
    name: 'blue',
    title: 'Blue mana',
    image: 'blueElement',
    active: true,
  },
  {
    name: 'green',
    title: 'Green mana',
    image: 'greenElement',
    active: false,
  }
];

